/*
  Main File, 1st file to execute in project
*/

import React from 'react';
import ReactDOM from 'react-dom';
import BootSetup from './BootSetup'

ReactDOM.render(
  <BootSetup/>,
  document.getElementById('root')
);